import { render, staticRenderFns } from "./AppMenu.vue?vue&type=template&id=53448058&scoped=true"
import script from "./AppMenu.vue?vue&type=script&lang=ts"
export * from "./AppMenu.vue?vue&type=script&lang=ts"
import style0 from "./AppMenu.vue?vue&type=style&index=0&id=53448058&prod&scoped=true&lang=scss"
import style1 from "./AppMenu.vue?vue&type=style&index=1&id=53448058&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53448058",
  null
  
)

export default component.exports